import { Link } from "react-router-dom";

const CardEnterprise = (props) => {
  return (
    <>
      <div className={`col-xl-3 col-sm-6 pb-3 hover-card ${props.disabled && "p-disabled"} ${props.className}`} onClick={props.onClick}>
        <Link to={props.link} state={props.params ? props.params : null}>
          <div className={props.color} style={{ height: "100%" }}>
            <div className="stats-icon stats-icon-lg">{props.icon}</div>
            <div className="stats-content">
              <div className="stats-number">{props.title}</div>
              {/* <div className="stats-progress progress">
                <div className="progress-bar" style={{ width: "70.1%" }}></div>
              </div> */}
              <div className="stats-desc pt-3">
                <div className="stats-link">
                  Ver Detalhes <i className="fa fa-arrow-alt-circle-right"></i>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default CardEnterprise;
